import AxiosService from './AxiosService'

class AdminRestService {
  get(): Promise<any> {
    return AxiosService.get('/admins')
  }

  create(admin: any): Promise<any> {
    return AxiosService.post('/admins/', admin)
  }

  update(admin: any): Promise<any> {
    return AxiosService.put('/admins/' + admin.id, admin)
  }

  delete(id: any): Promise<any> {
    return AxiosService.delete('/admins/' + id)
  }

  getAssignedRoles(id: number): Promise<any> {
    return AxiosService.get(`/admins/${id}/roles/`)
  }

  updateAssignedRoles(id: number, roles: number[]): Promise<any> {
    return AxiosService.put(`/admins/${id}/roles/`, roles)
  }
}

export default new AdminRestService()
